import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { collectArrayFieldErrors } from '../utils/apiFieldErrors';

const NestedFieldErrorsAlert = ({ errors, arrayName, itemLabel = 'Item', title }) => {
  const fieldErrors = collectArrayFieldErrors(errors, arrayName);

  if (!fieldErrors.length) {
    return null;
  }

  return (
    <Alert severity="error" sx={{ mt: 1, mb: 1 }}>
      {title && <AlertTitle>{title}</AlertTitle>}
      <Box component="ul" sx={{ m: 0, pl: 2 }}>
        {fieldErrors.map(({ index, messages }) =>
          messages.map((message) => (
            <li key={`${arrayName}-${index ?? 'root'}-${message}`}>
              {index == null ? message : `${itemLabel} ${index + 1}: ${message}`}
            </li>
          )),
        )}
      </Box>
    </Alert>
  );
};

export default NestedFieldErrorsAlert;
